import { axios } from '../../utilities/axiosClient'
import { EventDetail } from '../../types/Event'

export const getEventDetail = (id: number): Promise<EventDetail> =>
  axios.get(`/api/event/${id}`)
